import { Link } from '~/components'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ArrowLeftBoldIcon from '~/components/Icons/svgs/ArrowLeftBoldIcon'

const CurriculumBackButton = ({ url }: { url: string }): React.ReactElement => {
  return (
    <Link to={url}>
      <div className="cursor-pointer p-3 -ml-4 w-40">
        <SVGIcon icon={ArrowLeftBoldIcon} pathClassName="text-white" size={24} />
      </div>
    </Link>
  )
}

export default CurriculumBackButton
